<script setup lang="ts">
import { inject } from 'vue'

const props = defineProps<{
  value: string | number
  disabled?: boolean
}>()

const { modelValue, updateModelValue } = inject('select', {
  modelValue: { value: undefined },
  updateModelValue: () => {}
})

const selectValue = () => {
  if (props.disabled) {
    return
  }

  updateModelValue(props.value)
}
</script>

<template>
  <button
    type="button"
    :disabled="disabled"
    @click="selectValue"
    class="relative flex w-full cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none hover:bg-accent hover:text-accent-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
    :class="{
      'bg-accent text-accent-foreground': !disabled && props.value === modelValue
    }"
  >
    <slot />
  </button>
</template> 